import Footer from "../components/footer"
import { resultList } from "../assets/list/resultList"
import Facebook from "../assets/images/facebook.png"
import Twitter from "../assets/images/twitter.png"
import parse from 'html-react-parser';
import {FacebookShareButton, TwitterShareButton } from 'react-share';

const Result = () => {

  const answer1 = localStorage.getItem("Answer1");
  const answer2 = localStorage.getItem("Answer2");
  const answer3 = localStorage.getItem("Answer3");
  const answer4 = localStorage.getItem("Answer4");
  const answer5 = localStorage.getItem("Answer5");
  const answer6 = localStorage.getItem("Answer6");
  const answer7 = localStorage.getItem("Answer7");
  const answer8 = localStorage.getItem("Answer8");
  const answer9 = localStorage.getItem("Answer9");
  const answer10 = localStorage.getItem("Answer10");
  const answer11 = localStorage.getItem("Answer11");
  const answer12 = localStorage.getItem("Answer12");

  const sumA = Number(answer1) +  Number(answer2) +  Number(answer3) +  Number(answer4) +  Number(answer5) +  Number(answer6) +  Number(answer7) ;
  const sumB = Number(answer8) +  Number(answer9) +  Number(answer10) +  Number(answer11) +  Number(answer12); 

  let typeA = 0
  switch (sumA) {
    case 0:
    case 1:
      typeA = 1
      break
    case 2:
    case 3:
    case 4:
      typeA = 2
      break
    default:
      typeA = 3
  }
  let typeB = 0
  switch (sumB) {
    case 0:
    case 1:
      typeB = 1
      break
    case 2:
    case 3:
      typeB = 2
      break
    default:
      typeB = 3
  }
  let catType = 0
  let catname = "cat"
  
  switch (String(typeA) + String(typeB)) {
    case "11":
      catType = 1
      catname = "ビターチェリー"
      break
    case "12":
      catType = 2
      catname = "レモン"
      break
    case "13":
      catType = 3
      catname = "キウイ"
      break
    case "21":
      catType = 4
      catname = "パイナップル"
      break
    case "22":
      catType = 5
      catname = "ブルーベリー"
      break
    case "23":
      catType = 6
      catname = "洋ナシ"
      break
    case "31":
      catType = 7
      catname = "いちご"
      break
    case "32":
      catType = 8
      catname = "アップル"
      break
    default:
      catType = 9
      catname = "フルーツバスケット"
  }

  const requestOptions ={
    method: 'POST',
    headers:{'Content-Type': 'application/json'},
    body: JSON.stringify([{
      "impression": localStorage.getItem("impression"),
      "question1": answer1,
      "question2": answer2,
      "question3": answer3,
      "question4": answer4,
      "question5": answer5,
      "question6": answer6,
      "question7": answer7,
      "question8": answer8,
      "question9": answer9,
      "question10": answer10,
      "question11": answer11,
      "question12": answer12,
      "cat_type": catname
    }])
  };
  fetch("https://suama-catscafe.com/nanineko/recv_data.php",requestOptions)

  return (
    <div className="result_area">
      {resultList.map((result) => (
      catType === result.id &&
        <div>
          <div className="margin_pc_result">
            <div className="p-relative">
              <img
                src={`${process.env.PUBLIC_URL}/img/cat/result/r_cat_bg_sp_${catType}.png`}
                alt={result.type}
                className="result-cat-bg sp anime_fadein"
              />
              <img
                src={`${process.env.PUBLIC_URL}/img/cat/result/r_cat_bg_pc_${catType}.png`}
                alt={result.type}
                className="result-cat-bg pc anime_fadein"
              />
              <img
                src={`${process.env.PUBLIC_URL}/img/cat/result/r_cat_${catType}.png`}
                alt={result.type}
                className="result-cat anime_korokoro_sp sp"
              />
              <img
                src={`${process.env.PUBLIC_URL}/img/cat/result/r_cat_${catType}.png`}
                alt={result.type}
                className="result-cat anime_korokoro_pc pc"
              />
            </div>
            <div className="result_text anime_fadein">
              <h2>{result.type}さんの特徴</h2>
              <p>{result.text1}<br /><br /> {parse(result.text2)}</p>
            </div>
            <div className="result_text anime_fadein">
              <h2>動物行動学者 入交先生のコメント</h2>
              <p>{result.advice}</p>
            </div>
            <img
              src={`${process.env.PUBLIC_URL}/img/cat/result/r_cat_share_sp_${catType}.png`}
              alt={result.type}
              className="result_share_img sp anime_fadein"
            />
            <img
              src={`${process.env.PUBLIC_URL}/img/cat/result/r_cat_share_pc_${catType}.png`}
              alt={result.type}
              className="result_share_img pc anime_fadein"
            />
          </div>
          <div className="sns">
            <p>この診断をシェアする！</p>
            <div className="flex-center">
                <FacebookShareButton url={"https://suama-catscafe.com/nanineko/"} quote={`あなたの愛猫さんは「${result.type}」でした。 #うちの子何猫ねこ`}>
                  <img alt="facebook" src={ Facebook } />
                </FacebookShareButton>
                <TwitterShareButton url={"https://suama-catscafe.com/nanineko/"} title={`あなたの愛猫さんは「${result.type}」でした。 #うちの子何猫ねこ`}>
                  <img alt="twitter" src={ Twitter } />
                </TwitterShareButton>
            </div>
          </div>
          <Footer />
        </div>
      ))}
    </div>
  )
}
  
  export default Result